(function (window, document) {
'use strict';

if (window.ForeFrontFFLAI && window.ForeFrontFFLAI.version) return;

var VERSION = '1.1.0';
var SESSION_KEY = 'forefrontFflaiSession:v1';
var LEARNING_KEY = 'forefrontFflaiLearning:v1';

function normalize(value) {
  return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

function safeSessionId() {
  try {
    var current = window.sessionStorage.getItem(SESSION_KEY);
    if (current) return current;
    current = 'ffs-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    window.sessionStorage.setItem(SESSION_KEY, current);
    return current;
  } catch (error) {
    return 'ffs-session';
  }
}

function sanitizeQuery(value) {
  return String(value || '')
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/ig, '[email removed]')
    .replace(/(?:\+?1[\s.-]?)?(?:\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}/g, '[phone removed]')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 160);
}

function metadata(product) {
  var tags = Array.isArray(product && product.tags)
    ? product.tags
    : String(product && product.tags || '').split(',');
  var data = {
    type: '',
    family: '',
    ribbon: '',
    equipment: '',
    models: [],
    brand: '',
    material: '',
    width: null,
    height: null,
    core: null,
    od: null,
    continuous: false,
    applications: [],
    priority: 0
  };

  tags.forEach(function (rawTag) {
    var tag = String(rawTag || '').trim().toLowerCase();
    if (tag.indexOf('fflai:') !== 0) return;
    var parts = tag.split(':');
    if (parts.length < 3) return;
    var key = parts[1];
    var value = parts.slice(2).join(':').trim();

    if (key === 'model') data.models.push(normalize(value));
    else if (key === 'type') data.type = value;
    else if (key === 'family') data.family = value;
    else if (key === 'ribbon') data.ribbon = value;
    else if (key === 'equipment') data.equipment = value;
    else if (key === 'brand') data.brand = normalize(value);
    else if (key === 'material') data.material = value.replace(/[-_]+/g, ' ');
    else if (key === 'application') data.applications.push(value.replace(/[-_]+/g, ' '));
    else if (['width', 'height', 'core', 'od', 'priority'].indexOf(key) !== -1) {
      var numberValue = Number(value);
      if (isFinite(numberValue)) data[key] = numberValue;
    } else if (key === 'continuous') {
      data.continuous = ['1', 'true', 'yes'].indexOf(value) !== -1;
    }
  });

  return data;
}

function productText(product) {
  return [product && product.title, product && product.vendor, product && product.product_type, product && product.tags].join(' ').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
}

function inferProductFamily(product) {
  var text = productText(product);
  if (/thermal (?:transfer )?ribbons?|wax resin|resin ribbons?|ttr ribbons?/.test(text)) return 'thermal-ribbons';
  if ((/direct thermal|thermal transfer/.test(text) || /zebra|cab|sato|tsc|honeywell|datamax|brady|citizen|toshiba|godex|rollo|munbyn/.test(text)) && /labels?|media|fanfold|rolls?/.test(text)) return 'thermal-labels';
  if ((/thermal|barcode|zebra|cab|sato|tsc|honeywell|datamax|brady|citizen|toshiba|godex|rollo|munbyn/.test(text)) && /printers?/.test(text)) return 'thermal-printers';
  if (/rewinder|unwinder|applicator|dispenser|finishing equipment|slitter|finisher/.test(text)) return 'finishing-equipment';
  if (/label makers?|tape cartridges?|brother.*tape|dymo.*tape/.test(text)) return 'label-makers-tapes';
  if (/label software|bartender|nicelabel|software license/.test(text)) return 'software';
  if (/custom printed|finished labels|printed labels/.test(text)) return 'custom-labels';
  if (/inkjet/.test(text) && /labels?|media|rolls?/.test(text)) return 'inkjet-labels';
  if (/(?:colorworks|colour label|color label|inkjet label).*printers?|printers?.*(?:colorworks|colour label|color label|inkjet label)/.test(text)) return 'color-printers';
  if (/\b(?:ink|inks|cartridge|cartridges|maintenance box|waste ink|toner|toners)\b/.test(text)) return 'ink-maintenance';
  if (/labels?|media|rolls?/.test(text)) return 'labels';
  return 'other';
}

function detectIntent(value) {
  var query = String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  var result = { family: 'all', subfamily: '', collection: '/collections/all', label: 'All ForeFront products' };
  if (/thermal (?:transfer )?ribbons?|wax resin|resin ribbons?|ttr ribbons?|ribbon/.test(query)) result = { family:'thermal-ribbons', subfamily:/wax resin/.test(query)?'wax-resin':/resin/.test(query)?'resin':/wax/.test(query)?'wax':'', collection:'/collections/thermal-ribbons', label:'Thermal ribbons' };
  else if (/(?:thermal|barcode|zebra|cab|sato|tsc|honeywell|datamax|brady|citizen|toshiba|godex|rollo|munbyn)/.test(query) && /printers?/.test(query)) result = { family:'thermal-printers', subfamily:'', collection:'/collections/thermal-printers', label:'Thermal label printers' };
  else if (/direct thermal|thermal transfer|thermal labels?|shipping labels?|barcode labels?|fanfold labels?|(?:zebra|cab|sato|tsc|honeywell|datamax|brady|citizen|toshiba|godex|rollo|munbyn).{0,24}(?:labels?|media|rolls?)/.test(query)) result = { family:'thermal-labels', subfamily:/direct thermal/.test(query)?'direct-thermal':/thermal transfer/.test(query)?'thermal-transfer':'', collection:/direct thermal/.test(query)?'/collections/direct-thermal-labels':/thermal transfer/.test(query)?'/collections/thermal-transfer-labels':'/collections/thermal-labels', label:/direct thermal/.test(query)?'Direct thermal labels':/thermal transfer/.test(query)?'Thermal transfer labels':'Thermal labels' };
  else if (/rewinder|unwinder|applicator|dispenser|finishing|slitter|finisher|label equipment/.test(query)) result = { family:'finishing-equipment', subfamily:'', collection:'/collections/finishing-equipment', label:'Finishing equipment' };
  else if (/label makers?|label tapes?|tape cartridges?|brother.*tape|dymo.*tape/.test(query)) result = { family:'label-makers-tapes', subfamily:'', collection:'/collections/label-makers-tapes', label:'Label makers and tapes' };
  else if (/label software|bartender|nicelabel|software/.test(query)) result = { family:'software', subfamily:'', collection:'/collections/software', label:'Label software' };
  else if (/custom printed|printed labels|finished labels|ready to apply/.test(query)) result = { family:'custom-labels', subfamily:'', collection:'/pages/product-label-printing', label:'Custom printed labels' };
  else if (/\b(?:ink|inks|cartridge|cartridges|maintenance|waste ink|toner|toners)\b/.test(query)) result = { family:'ink-maintenance', subfamily:'', collection:'/collections/inks-toners', label:'Ink and maintenance' };
  else if (/colour label printers?|color label printers?|colorworks|inkjet label printers?/.test(query)) result = { family:'color-printers', subfamily:'', collection:'/collections/color-label-printers', label:'Colour label printers' };
  else if (/inkjet|bopp|blank labels?|label rolls?|continuous labels?/.test(query)) result = { family:'inkjet-labels', subfamily:'', collection:'/collections/inkjet-labels', label:'Inkjet label rolls' };
  return result;
}

function productKey(product) {
  var raw = String(product && (product.url || product.handle || product.id) || '').split('?')[0];
  return normalize(raw);
}

function readLearning() {
  try {
    var parsed = JSON.parse(window.sessionStorage.getItem(LEARNING_KEY) || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
}

function rememberResultClick(details) {
  var href = String(details && details.href || '').split('?')[0];
  if (href.indexOf('/products/') === -1) return;
  var key = normalize(href);
  if (!key) return;
  try {
    var learning = readLearning();
    var current = learning[key] || { count: 0, last: 0 };
    learning[key] = { count: Math.min(Number(current.count || 0) + 1, 4), last: Date.now() };
    var entries = Object.keys(learning).map(function (entryKey) { return [entryKey, learning[entryKey]]; }).sort(function (a, b) { return Number(b[1].last || 0) - Number(a[1].last || 0); }).slice(0, 30);
    var trimmed = {};
    entries.forEach(function (entry) { trimmed[entry[0]] = entry[1]; });
    window.sessionStorage.setItem(LEARNING_KEY, JSON.stringify(trimmed));
  } catch (error) {}
}

function learnedProductBoost(product) {
  var key = productKey(product);
  var signal = key && readLearning()[key];
  return signal ? Math.min(Number(signal.count || 0) * 45, 180) : 0;
}

function scoreProduct(product, context) {
  var intelligence = metadata(product);
  var ctx = context || {};
  var parsed = ctx.parsed || {};
  var query = String(ctx.query || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  var modelToken = normalize(ctx.modelToken || (parsed.printer && parsed.printer.model));
  var supply = String(ctx.supply || parsed.supply || '').toLowerCase();
  var material = String(ctx.material || parsed.material || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  var score = (intelligence.priority || 0) + learnedProductBoost(product);
  var family = intelligence.family || inferProductFamily(product);
  var intent = ctx.intent || detectIntent(query);
  var searchable = [product && product.title, product && product.vendor, product && product.product_type].join(' ').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  var queryTokens = query.split(/\s+/).filter(function (token) { return token.length > 1; });
  var matchedTokens = 0;
  queryTokens.forEach(function (token) { if (searchable.indexOf(token) !== -1) matchedTokens += 1; });
  score += matchedTokens * 140;
  if (normalize(query).length > 3 && normalize(searchable).indexOf(normalize(query)) !== -1) score += 420;
  if (intent.family !== 'all') score += family === intent.family ? 2200 : (family !== 'other' ? -850 : 0);
  if (intent.subfamily === 'direct-thermal') score += /direct thermal/.test(searchable) ? 520 : (/thermal transfer/.test(searchable) ? -420 : 0);
  if (intent.subfamily === 'thermal-transfer') score += /thermal transfer/.test(searchable) ? 520 : (/direct thermal/.test(searchable) ? -420 : 0);
  if (intent.subfamily === 'wax-resin') score += /wax resin/.test(searchable) ? 420 : 0;
  else if (intent.subfamily === 'resin') score += /resin/.test(searchable) && !/wax resin/.test(searchable) ? 420 : 0;
  else if (intent.subfamily === 'wax') score += /wax/.test(searchable) && !/wax resin/.test(searchable) ? 420 : 0;

  if (modelToken && intelligence.models.indexOf(modelToken) !== -1) score += 1200;
  if (material && intelligence.material.indexOf(material) !== -1) score += 450;
  if ((parsed.printerBuyingIntent || /\b(?:buy|need|recommend|choose).{0,24}printer\b/i.test(query)) && intelligence.type === 'printer') score += 1900;
  if ((supply === 'ink' || /\b(?:ink|cartridge|cmyk)\b/i.test(query)) && ['ink', 'ink-set', 'ink-maintenance-set'].indexOf(intelligence.type) !== -1) {
    score += intelligence.type === 'ink-maintenance-set' ? 1900 : intelligence.type === 'ink-set' ? 1600 : 950;
  }
  if ((supply === 'maintenance' || /\b(?:maintenance|waste ink)\b/i.test(query)) && ['maintenance', 'maintenance-box', 'ink-maintenance-set'].indexOf(intelligence.type) !== -1) {
    score += intelligence.type === 'maintenance-box' ? 1800 : 1300;
  }
  if ((parsed.labelIntent || supply === 'labels' || /\b(?:labels?|rolls?|media)\b/i.test(query)) && ['label', 'labels', 'blank-label', 'custom-label'].indexOf(intelligence.type) !== -1) score += 950;
  intelligence.applications.forEach(function (application) {
    if (query.indexOf(application) !== -1) score += 550;
  });

  return score;
}

function track(eventName, details) {
  if (eventName === 'fflai_result_click') rememberResultClick(details);
  var payload = Object.assign({
    event: eventName,
    finder: 'ForeFront Smart Finder',
    fflaiVersion: VERSION,
    fflaiSession: safeSessionId()
  }, details || {});

  if (Object.prototype.hasOwnProperty.call(payload, 'query')) payload.query = sanitizeQuery(payload.query);
  if (Object.prototype.hasOwnProperty.call(payload, 'correctedQuery')) payload.correctedQuery = sanitizeQuery(payload.correctedQuery);

  if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  try {
    document.dispatchEvent(new CustomEvent('forefront:fflai', { detail: payload }));
  } catch (error) {
    return payload;
  }
  return payload;
}

window.ForeFrontFFLAI = {
  version: VERSION,
  metadata: metadata,
  detectIntent: detectIntent,
  inferProductFamily: inferProductFamily,
  scoreProduct: scoreProduct,
  sanitizeQuery: sanitizeQuery,
  track: track
};
})(window, document);
